import { render, staticRenderFns } from "./TableDiagnoses.vue?vue&type=template&id=937f9f72"
import script from "./TableDiagnoses.vue?vue&type=script&lang=js"
export * from "./TableDiagnoses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports